import { client } from '@hotjar/api-base-client';
import { clientBaseConfig } from './base';
import type { OrderRequestDto } from './dto';
import { mapSubscriptionReactivationRequestModelToDto } from './mapper';
import type { OrderProcessResponse, SubscriptionReactivationRequest } from './model';

export async function reactivateOrder(
  data: SubscriptionReactivationRequest,
): Promise<OrderProcessResponse> {
  return client<
    OrderProcessResponse,
    undefined,
    SubscriptionReactivationRequest,
    OrderRequestDto<'reactivate_subscription_order'>
  >({
    ...clientBaseConfig,
    data,
    mapRequestData: mapSubscriptionReactivationRequestModelToDto,
  });
}
